import { parseHomeTableData } from "../libs/hooks/useParseTableData/parseHomeTableData";
import { HomeTableColumns } from "../libs/store/columns";
import { IndexTable } from "@shopify/polaris";

export namespace HomeTableCells {
  export type RowDataType = ReturnType<typeof parseHomeTableData>[number];
  interface ColumnCellProps {
    row: RowDataType;
  }

  export const Cells: Record<HomeTableColumns.Column, (info: ColumnCellProps) => JSX.Element> = {
    shopifyId({ row }) {
      return <IndexTable.Cell>{row.shopifyId}</IndexTable.Cell>;
    },
    upcomingOrderDate({ row }) {
      return <IndexTable.Cell>{row.upcomingOrderDate}</IndexTable.Cell>;
    },
    emailOrName({ row }) {
      return <IndexTable.Cell>{row.emailOrName}</IndexTable.Cell>;
    },
    email({ row }) {
      return <IndexTable.Cell>{row.email}</IndexTable.Cell>;
    },
    estimatedTotal({ row }) {
      return <IndexTable.Cell>{row.estimatedTotal}</IndexTable.Cell>;
    },
    items({ row }) {
      return <IndexTable.Cell>{row.items}</IndexTable.Cell>;
    },
    status({ row }) {
      return <IndexTable.Cell>{row.status}</IndexTable.Cell>;
    },
    createdDate({ row }) {
      return <IndexTable.Cell>{row.createdDate}</IndexTable.Cell>;
    },
    sellingPlanId({ row }) {
      return <IndexTable.Cell>{row.sellingPlanId}</IndexTable.Cell>;
    },
    cancellationReason({ row }) {
      return <IndexTable.Cell>{row.cancellationReason}</IndexTable.Cell>;
    },
    action({ row }) {
      return <IndexTable.Cell>{row.action}</IndexTable.Cell>;
    },
  };
}
